Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '';
__p += 'Loading...\n';
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/formiojs/templates/bootstrap/loading/form.ejs.js
// module id = 3268
// module chunks = 0